import { render, staticRenderFns } from "./register.vue?vue&type=template&id=fb08782a&scoped=true&"
import script from "./register.vue?vue&type=script&lang=js&"
export * from "./register.vue?vue&type=script&lang=js&"
import style0 from "./register.vue?vue&type=style&index=0&id=fb08782a&lang=scss&scoped=true&"
import style1 from "./register.vue?vue&type=style&index=1&id=fb08782a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb08782a",
  null
  
)

export default component.exports